import { createFileRoute } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { suspenseOptions } from "@/lib/suspense-query";
import { getGetEntityQueryOptions } from "@/requests/gen/react-query/entity";
import { ServicesForm } from "./-form";
import { EntityCrumbs } from "../../-crumbs";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import numericId from "@/lib/numeric-id";

export const Route = createFileRoute(
  "/_private/_admin/entity/$entityId/services/",
)({
  loader: ({ context: { queryClient }, params: { entityId } }) =>
    queryClient.ensureQueryData(getGetEntityQueryOptions(numericId(entityId))),
  component: ServicePermissionsPage,
});

function ServicePermissionsPage() {
  const { entityId } = Route.useParams();
  // Fetch the entity data
  const { data: entity } = useSuspenseQuery(
    suspenseOptions(getGetEntityQueryOptions(numericId(entityId))),
  );

  return (
    <div>
      <title>{`Edit ${entity?.name} Services - Legrande Health Portal`}</title>
      <EntityCrumbs />

      <Card>
        <CardHeader>
          <CardTitle>Service Permissions</CardTitle>
          <CardDescription>
            Manage access to services for {entity?.entity_type} {entity?.name}
          </CardDescription>
        </CardHeader>
        <CardContent>{entity && <ServicesForm entity={entity} />}</CardContent>
      </Card>
    </div>
  );
}
